/**
 * LoadMore Component
 *
 * Simple "Load More" button for infinite scroll pattern
 */

import React from 'react';
import { Button } from '@/components/ui/button';

/**
 * LoadMore Component
 *
 * Simple "Load More" button for infinite scroll pattern
 */
export interface LoadMoreProps {
  hasMore: boolean;
  onLoadMore: () => void;
  isLoading?: boolean;
  className?: string;
  labels?: {
    loadMore?: string;
    loading?: string;
    noMore?: string;
  };
}

export function LoadMore({
  hasMore,
  onLoadMore,
  isLoading = false,
  className = '',
  labels = {},
}: LoadMoreProps) {
  const {
    loadMore = 'Load More',
    loading = 'Loading...',
    noMore = 'No more items',
  } = labels;


  return (
    <div className={`text-center ${className}`}>
      {hasMore ? (
        <Button
          variant="outline"
          onClick={onLoadMore}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <div className="w-4 h-4 border-2 border-gray-300 border-t-gray-700 rounded-full animate-spin" />
              {loading}
            </>
          ) : (
            loadMore
          )}
        </Button>
      ) : (
        <p className="text-sm text-gray-500">{noMore}</p>
      )}
    </div>
  );
}
